import React from "react";

const Item = ({ label, value, onChange, icon, isEditing }) => (
  <label className="ros-item">
    <span style={{ marginRight: 8 }}>{icon}</span>
    {label}
    <select value={value || 0} onChange={(e) => onChange(Number(e.target.value))} disabled={!isEditing}>
      <option value={0}>No</option>
      <option value={1}>Yes</option>
    </select>
  </label>
);

export default function RosFormTemplates({ ros, onChange, templateId, isEditing=true }) {
  const set = (k, v) => onChange({ ...ros, [k]: v });

  const allowedTemplateIds = ["100001773", "100001774"];

  if (!templateId || !allowedTemplateIds.includes(templateId)) {
    return null;
  }

  const is773 = templateId === "100001773";

  return (
    <div className="cn-card">
      <h3>🧩 Review of Systems (ROS)</h3>

      <h4>General / Constitutional</h4>
      <div className="row">
        <Item label="Chills" value={ros.chills} onChange={(v) => set("chills", v)} icon="❄️" isEditing={isEditing} />
        <Item label="Fever" value={ros.fever} onChange={(v) => set("fever", v)} icon="🌡️" isEditing={isEditing} />
        <Item label="Lightheadedness" value={ros.lightheadedness} onChange={(v) => set("lightheadedness", v)} icon="😵" isEditing={isEditing} />
        <Item label="Changes in appetite" value={ros.ChangesinAppetite} onChange={(v) => set("ChangesinAppetite", v)} icon="🍽️" isEditing={isEditing} />
        <Item label="Fatigue" value={ros.Fatigue} onChange={(v) => set("Fatigue", v)} icon="😴" isEditing={isEditing} />
        <Item label="Weight change" value={ros.WeightChange} onChange={(v) => set("WeightChange", v)} icon="⚖️" isEditing={isEditing} />
        {is773 && <Item label="Night sweats" value={ros.nightSweats} onChange={(v) => set("nightSweats", v)} icon="🌙" isEditing={isEditing} />}
      </div>

      <h4>Ophthalmologic</h4>
      <div className="row">
        <Item label="Vision changes" value={ros.VisionChanges} onChange={(v) => set("VisionChanges", v)} icon="👁️" isEditing={isEditing} />
        <Item label="Double vision" value={ros.Doublevision} onChange={(v) => set("Doublevision", v)} icon="👁️" isEditing={isEditing} />
        <Item label="Eye pain" value={ros.EyePain} onChange={(v) => set("EyePain", v)} icon="😣" isEditing={isEditing} />
        {is773 && <Item label="Eye redness" value={ros.eyeRedness} onChange={(v) => set("eyeRedness", v)} icon="🔴" isEditing={isEditing} />}
      </div>

      <h4>ENT / Nose / Throat</h4>
      <div className="row">
        <Item label="Decreased hearing" value={ros.Decreasedhearing} onChange={(v) => set("Decreasedhearing", v)} icon="👂" isEditing={isEditing} />
        <Item label="Ringing in the ears" value={ros.Ringingintheears} onChange={(v) => set("Ringingintheears", v)} icon="🔔" isEditing={isEditing} />
        <Item label="Ear pain" value={ros.EarPain} onChange={(v) => set("EarPain", v)} icon="😣" isEditing={isEditing} />
        <Item label="Nose bleed" value={ros.NoseBleed} onChange={(v) => set("NoseBleed", v)} icon="🩸" isEditing={isEditing} />
        <Item label="Nasal congestion" value={ros.NasalCongestion} onChange={(v) => set("NasalCongestion", v)} icon="👃" isEditing={isEditing} />
        <Item label="Sinus pain" value={ros.sinuspain} onChange={(v) => set("sinuspain", v)} icon="😣" isEditing={isEditing} />
        <Item label="Sore throat" value={ros.SoreThroat} onChange={(v) => set("SoreThroat", v)} icon="😣" isEditing={isEditing} />
        <Item label="Difficulty swallowing" value={ros.Difficultyswallowing} onChange={(v) => set("Difficultyswallowing", v)} icon="🍽️" isEditing={isEditing} />
        {is773 && <Item label="Hoarseness" value={ros.hoarseness} onChange={(v) => set("hoarseness", v)} icon="🔊" isEditing={isEditing} />}
      </div>

      <h4>Respiratory</h4>
      <div className="row">
        <Item label="Cough" value={ros.Cough} onChange={(v) => set("Cough", v)} icon="🤧" isEditing={isEditing} />
        <Item label="Shortness of breath" value={ros.Shortnessofbreath} onChange={(v) => set("Shortnessofbreath", v)} icon="🌬️" isEditing={isEditing} />
        <Item label="Wheezing" value={ros.Wheezing} onChange={(v) => set("Wheezing", v)} icon="🌪️" isEditing={isEditing} />
        <Item label="Hemoptysis" value={ros.Hemoptysis} onChange={(v) => set("Hemoptysis", v)} icon="🩸" isEditing={isEditing} />
        <Item label="Sputum production" value={ros.sputumproduction} onChange={(v) => set("sputumproduction", v)} icon="🤧" isEditing={isEditing} />
      </div>

      <h4>Cardiovascular</h4>
      <div className="row">
        <Item label="Chest pain" value={ros.Chestpain} onChange={(v) => set("Chestpain", v)} icon="💔" isEditing={isEditing} />
        <Item label="Chest pressure or chest discomfort" value={ros.ChestpressureorChestdiscomfort} onChange={(v) => set("ChestpressureorChestdiscomfort", v)} icon="💔" isEditing={isEditing} />
        <Item label="Palpitations" value={ros.Palpitations} onChange={(v) => set("Palpitations", v)} icon="💓" isEditing={isEditing} />
        <Item label="Irregular heartbeat" value={ros.Irregularheartbeat} onChange={(v) => set("Irregularheartbeat", v)} icon="💓" isEditing={isEditing} />
        <Item label="Difficulty laying flat" value={ros.difficultylayingflat} onChange={(v) => set("difficultylayingflat", v)} icon="🛏️" isEditing={isEditing} />
        <Item label="Dyspnea on exertion" value={ros.dyspneaonexertion} onChange={(v) => set("dyspneaonexertion", v)} icon="🌬️" isEditing={isEditing} />
        <Item label="Claudication" value={ros.Claudication} onChange={(v) => set("Claudication", v)} icon="🦵" isEditing={isEditing} />
      </div>

      <h4>Gastrointestinal</h4>
      <div className="row">
        <Item label="Abdominal pain" value={ros.Abdominalpain} onChange={(v) => set("Abdominalpain", v)} icon="🤰" isEditing={isEditing} />
        <Item label="Nausea" value={ros.Nausea} onChange={(v) => set("Nausea", v)} icon="🤢" isEditing={isEditing} />
        <Item label="Vomiting" value={ros.vomitting} onChange={(v) => set("vomitting", v)} icon="🤮" isEditing={isEditing} />
        <Item label="Change in bowel habits" value={ros.changeinbowelhabits} onChange={(v) => set("changeinbowelhabits", v)} icon="🚽" isEditing={isEditing} />
        <Item label="Anorexia" value={ros.anorexia} onChange={(v) => set("anorexia", v)} icon="🍽️" isEditing={isEditing} />
        <Item label="Blood in stool" value={ros.BloodinStool} onChange={(v) => set("BloodinStool", v)} icon="🩸" isEditing={isEditing} />
        <Item label="Diarrhea" value={ros.Diarrhea} onChange={(v) => set("Diarrhea", v)} icon="💩" isEditing={isEditing} />
        <Item label="Heartburn" value={ros.Heartburn} onChange={(v) => set("Heartburn", v)} icon="🔥" isEditing={isEditing} />
      </div>

      <h4>Genitourinary</h4>
      <div className="row">
        <Item label="Blood in the urine" value={ros.bloodintheurine} onChange={(v) => set("bloodintheurine", v)} icon="🩸" isEditing={isEditing} />
        <Item label="Difficulty urinating" value={ros.difficultyurinating} onChange={(v) => set("difficultyurinating", v)} icon="🚽" isEditing={isEditing} />
        <Item label="Pain in the lower back" value={ros.paininthelowerback} onChange={(v) => set("paininthelowerback", v)} icon="😣" isEditing={isEditing} />
      </div>

      <h4>Musculoskeletal</h4>
      <div className="row">
        <Item label="Painful joints" value={ros.painfuljoints} onChange={(v) => set("painfuljoints", v)} icon="🦴" isEditing={isEditing} />
        <Item label="Swollen joints" value={ros.Swollenjoints} onChange={(v) => set("Swollenjoints", v)} icon="💧" isEditing={isEditing} />
        <Item label="Cervical" value={ros.Cervical} onChange={(v) => set("Cervical", v)} icon="😣" isEditing={isEditing} />
        <Item label="Thoraxic" value={ros.Thoraxic} onChange={(v) => set("Thoraxic", v)} icon="😣" isEditing={isEditing} />
        <Item label="Lumbar" value={ros.Lumbar} onChange={(v) => set("Lumbar", v)} icon="😣" isEditing={isEditing} />
      </div>

      <h4>Neurologic</h4>
      <div className="row">
        <Item label="Paralysis" value={ros.Paralysis} onChange={(v) => set("Paralysis", v)} icon="😩" isEditing={isEditing} />
        <Item label="Seizures" value={ros.Seizures} onChange={(v) => set("Seizures", v)} icon="🧠" isEditing={isEditing} />
        <Item label="Tingling numbness" value={ros.TinglingNumbness} onChange={(v) => set("TinglingNumbness", v)} icon="👐" isEditing={isEditing} />
        <Item label="Dizziness" value={ros.Dizziness1} onChange={(v) => set("Dizziness1", v)} icon="⭕" isEditing={isEditing} />
        <Item label="Weakness" value={ros.weakness} onChange={(v) => set("weakness", v)} icon="😩" isEditing={isEditing} />
        <Item label="New onset headache" value={ros.Newonsetheadache} onChange={(v) => set("Newonsetheadache", v)} icon="🧠" isEditing={isEditing} />
        <Item label="Difficulty speaking" value={ros.Difficultyspeaking} onChange={(v) => set("Difficultyspeaking", v)} icon="😣" isEditing={isEditing} />
        <Item label="Headache" value={ros.Headache} onChange={(v) => set("Headache", v)} icon="🧠" isEditing={isEditing} />
        <Item label="Dizziness" value={ros.Dizziness} onChange={(v) => set("Dizziness", v)} icon="⭕" isEditing={isEditing} />
        <Item label="Loss of strength" value={ros.lossofstrength} onChange={(v) => set("lossofstrength", v)} icon="😩" isEditing={isEditing} />
        <Item label="Memory loss" value={ros.Memoryloss} onChange={(v) => set("Memoryloss", v)} icon="🧠" isEditing={isEditing} />
        <Item label="Abnormality" value={ros.abnormality} onChange={(v) => set("abnormality", v)} icon="😣" isEditing={isEditing} />
      </div>

      <h4>Endocrine</h4>
      <div className="row">
        <Item label="Cold intolerance" value={ros.Coldintolerance} onChange={(v) => set("Coldintolerance", v)} icon="❄️" isEditing={isEditing} />
        <Item label="Excessive thirst" value={ros.Excessivethirst} onChange={(v) => set("Excessivethirst", v)} icon="💧" isEditing={isEditing} />
        <Item label="Frequent urination" value={ros.frequenturination} onChange={(v) => set("frequenturination", v)} icon="💧" isEditing={isEditing} />
        <Item label="Heat intolerance" value={ros.Heatintolerance} onChange={(v) => set("Heatintolerance", v)} icon="🌡️" isEditing={isEditing} />
        <Item label="Excessive sweating" value={ros.excessivesweating} onChange={(v) => set("excessivesweating", v)} icon="💧" isEditing={isEditing} />
      </div>

      <h4>Psychiatric</h4>
      <div className="row">
        <Item label="Suicidal/homicidal thoughts" value={ros.Suicidalhomicidalthoughts} onChange={(v) => set("Suicidalhomicidalthoughts", v)} icon="😞" isEditing={isEditing} />
        <Item label="Difficulty sleeping" value={ros.DifficultySleeping} onChange={(v) => set("DifficultySleeping", v)} icon="😴" isEditing={isEditing} />
      </div>
    </div>
  );
}